import { defineStore } from "pinia";

interface ITheme {
  theme: string;
  size: number;
}

const getTheme = () => {
  const theme = localStorage.getItem("data-bs-theme");
  return theme ? theme : "dark";
};

const state = (): ITheme => ({
  theme: getTheme(),
  size: 0,
});

export const theme = defineStore("theme", {
  state,
  getters: {
    getTheme: (state: ITheme): string => {
      return state.theme;
    },
    screenWidth: (state: ITheme): number => {
      return state.size;
    },
  },
  actions: {
    setTheme(theme: string) {
      this.theme = theme;
      localStorage.setItem("data-bs-theme", theme);
    },
    setWidth(size: number) {
      this.size = size;
    },
  },
});
